// extracted by mini-css-extract-plugin
module.exports = {"StoriesGridImage":"styles_StoriesGridImage__Eucv0","item":"styles_item__Aq4I6","ratio":"styles_ratio__SGZ9w"};